module.exports = __webpack_public_path__ + "static/media/submitPayment.988638b6.svg";